<template>
  <div class="text-h6 mt-1 mb-1 grey--text text--lighten-3">
    <v-icon small color="grey lighten-3">mdi-timer-outline</v-icon>
    {{ formattedElapsed }}
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "AlarmTimer",
  props: {
    startTime: {
      type: [String, Object, Date],
      required: true,
    },
  },
  data() {
    return {
      elapsed: 0,
      intervalId: null,
    };
  },
  computed: {
    formattedElapsed() {
      const totalSeconds = Math.floor(this.elapsed / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const format = (num) => num.toString().padStart(2, "0");

      if (hours > 0) {
        return `${format(hours)}:${format(minutes)}:${format(seconds)}`;
      }
      return `${format(minutes)}:${format(seconds)}`;
    },
  },
  methods: {
    updateTimer() {
      const start = dayjs(this.startTime);
      const now = dayjs();
      this.elapsed = now.diff(start);
    },
  },
  mounted() {
    this.updateTimer();
    this.intervalId = setInterval(this.updateTimer, 1000);
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
};
</script>
